module.exports = __webpack_public_path__ + "img/37_BF15_under_water.976c1328.jpg";